{
  "app": {
    "name": "مباراتي",
    "tagline": "نظام إدارة الحكام والمباريات"
  },
  "actions": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "delete": "حذف",
    "add": "إضافة",
    "edit": "تعديل",
    "close": "إغلاق",
    "search": "بحث",
    "filter": "تصفية",
    "export": "تصدير",
    "import": "استيراد",
    "download": "تحميل",
    "print": "طباعة",
    "refresh": "تحديث",
    "view": "عرض",
    "back": "رجوع",
    "next": "التالي",
    "previous": "السابق",
    "submit": "إرسال",
    "reset": "إعادة تعيين",
    "apply": "تطبيق",
    "clear": "مسح",
    "select": "اختيار",
    "create": "إنشاء",
    "update": "تحديث",
    "validate": "التحقق",
    "reject": "رفض",
    "approve": "موافقة",
    "archive": "أرشفة",
    "restore": "استعادة",
    "send": "إرسال",
    "generate": "توليد",
    "copy": "نسخ",
    "paste": "لصق",
    "upload": "رفع",
    "open": "فتح",
    "expand": "توسيع",
    "collapse": "طي",
    "more": "المزيد",
    "less": "أقل",
    "show_all": "عرض الكل",
    "hide": "إخفاء",
    "show": "إظهار",
    "home": "العودة للرئيسية",
    "retry": "حاول مرة أخرى",
    "ok": "موافق",
    "history": "السجل التاريخي"
  },
  "alert": {
    "why_label": "لماذا :",
    "action_label": "الإجراء :"
  },
  "date_placeholder": "يي/شش/سسسس",
  "datepicker": {
    "select_month": "اختر شهراً",
    "select_year": "اختر سنة",
    "change_year": "تغيير السنة",
    "today": "اليوم"
  },
  "status": {
    "active": "نشط",
    "inactive": "غير نشط",
    "pending": "قيد الانتظار",
    "approved": "موافق عليه",
    "rejected": "مرفوض",
    "completed": "مكتمل",
    "cancelled": "ملغى",
    "draft": "مسودة",
    "published": "منشور",
    "suspended": "موقوف",
    "blocked": "محظور",
    "open": "مفتوح",
    "closed": "مغلق",
    "in_progress": "قيد التنفيذ",
    "paid": "مدفوع",
    "unpaid": "غير مدفوع",
    "partial": "جزئي"
  },
  "labels": {
    "name": "الاسم",
    "name_ar": "الاسم (عربي)",
    "first_name": "الاسم الأول",
    "last_name": "اللقب",
    "full_name": "الاسم الكامل",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "date": "التاريخ",
    "time": "الوقت",
    "description": "الوصف",
    "notes": "ملاحظات",
    "status": "الحالة",
    "type": "النوع",
    "category": "الفئة",
    "role": "الدور",
    "code": "الرمز",
    "number": "الرقم",
    "amount": "المبلغ",
    "total": "المجموع",
    "address": "العنوان",
    "city": "المدينة",
    "country": "البلد",
    "region": "المنطقة",
    "created_at": "تاريخ الإنشاء",
    "updated_at": "تاريخ التعديل",
    "created_by": "أنشئ بواسطة",
    "id": "المعرّف",
    "season": "الموسم",
    "league": "الرابطة",
    "club": "النادي",
    "match": "المباراة",
    "official": "الرسمي",
    "referee": "الحكم",
    "observer": "المراقب",
    "date_of_birth": "تاريخ الميلاد",
    "age": "العمر",
    "gender": "الجنس",
    "nationality": "الجنسية",
    "wilaya": "الولاية",
    "grade": "الدرجة",
    "level": "المستوى",
    "function": "المهمة",
    "salary": "الراتب",
    "payment": "الدفع",
    "document": "الوثيقة",
    "file": "الملف",
    "image": "الصورة",
    "logo": "الشعار",
    "website": "الموقع الإلكتروني",
    "comments": "التعليقات",
    "reason": "السبب",
    "source": "المصدر"
  },
  "boolean": {
    "yes": "نعم",
    "no": "لا",
    "none": "لا شيء",
    "all": "الكل",
    "other": "أخرى"
  },
  "loading": {
    "loading": "جارٍ التحميل…",
    "please_wait": "يرجى الانتظار…",
    "initializing": "جارٍ تهيئة التطبيق…",
    "loading_settings": "جارٍ تحميل الإعدادات العامة…",
    "saving": "جارٍ الحفظ…",
    "deleting": "جارٍ الحذف…",
    "sending": "جارٍ الإرسال…",
    "generating": "جارٍ التوليد…",
    "processing": "جارٍ المعالجة…",
    "disconnecting": "جارٍ تسجيل الخروج…"
  },
  "errors": {
    "generic": "حدث خطأ ما",
    "network": "خطأ في الشبكة. تحقق من اتصالك.",
    "unauthorized": "غير مصرح بالوصول",
    "not_found": "المورد غير موجود",
    "required": "هذا الحقل مطلوب",
    "invalid_email": "عنوان البريد الإلكتروني غير صالح",
    "invalid_format": "تنسيق غير صالح",
    "min_length": "الحد الأدنى {{count}} حرف",
    "max_length": "الحد الأقصى {{count}} حرف",
    "try_again": "حاول مرة أخرى",
    "contact_support": "تواصل مع الدعم",
    "no_data": "لا تتوفر بيانات",
    "load_failed": "فشل التحميل",
    "save_failed": "فشل الحفظ",
    "delete_failed": "فشل الحذف",
    "label": "خطأ",
    "league_access_denied_title": "تم رفض الوصول",
    "league_access_denied": "هذه الرابطة خارج نطاق صلاحياتك: لا يمكنك الاطلاع على بياناتها التأديبية.",
    "load_failed_description": "تعذر تحميل البيانات. أعد المحاولة بعد قليل.",
    "module_access_denied": "ليست لديك صلاحية الوصول إلى الوحدة التأديبية."
  },
  "notifications": {
    "success": "نجاح",
    "error": "خطأ",
    "warning": "تحذير",
    "info": "معلومة",
    "saved": "تم الحفظ بنجاح",
    "deleted": "تم الحذف بنجاح",
    "updated": "تم التحديث بنجاح",
    "created": "تم الإنشاء بنجاح",
    "exported": "تم التصدير بنجاح",
    "imported": "تم الاستيراد بنجاح",
    "sent": "تم الإرسال بنجاح",
    "copied": "تم النسخ إلى الحافظة",
    "save_failed": "خطأ أثناء الحفظ."
  },
  "pagination": {
    "page": "صفحة",
    "of": "من",
    "showing": "عرض",
    "to": "إلى",
    "results": "نتائج",
    "total": "المجموع",
    "per_page": "في الصفحة",
    "first": "الأول",
    "last": "الأخير",
    "no_results": "لا توجد نتائج",
    "rows_option": "{{count}} صفوف",
    "page_of": "صفحة {{page}} من {{total}}",
    "prev_label": "السابق ›",
    "next_label": "‹ التالي",
    "no_results_short": "لا توجد نتائج.",
    "select_placeholder": "اختيار...",
    "search_placeholder": "بحث..."
  },
  "confirm_delete": {
    "title": "تأكيد الحذف",
    "message": "هل أنت متأكد أنك تريد حذف هذا العنصر؟ هذا الإجراء لا يمكن التراجع عنه.",
    "confirm_text": "حذف",
    "cancel_text": "إلغاء"
  },
  "empty_state": {
    "title": "لا توجد عناصر",
    "description": "لا يوجد شيء لعرضه في الوقت الحالي.",
    "action": "إنشاء أول عنصر"
  },
  "months": {
    "january": "يناير",
    "february": "فبراير",
    "march": "مارس",
    "april": "أبريل",
    "may": "مايو",
    "june": "يونيو",
    "july": "يوليو",
    "august": "أغسطس",
    "september": "سبتمبر",
    "october": "أكتوبر",
    "november": "نوفمبر",
    "december": "ديسمبر"
  },
  "days": {
    "monday": "الإثنين",
    "tuesday": "الثلاثاء",
    "wednesday": "الأربعاء",
    "thursday": "الخميس",
    "friday": "الجمعة",
    "saturday": "السبت",
    "sunday": "الأحد"
  },
  "language": {
    "fr": "الفرنسية",
    "ar": "العربية",
    "french": "Français",
    "arabic": "عربي",
    "switch_to_arabic": "التبديل إلى العربية",
    "switch_to_french": "التبديل إلى الفرنسية"
  },
  "filters": {
    "all": "الكل",
    "active_filters": "الفلاتر النشطة",
    "clear_filters": "مسح الفلاتر",
    "no_filters": "لا توجد فلاتر نشطة",
    "filter_by": "تصفية حسب"
  },
  "table": {
    "actions": "الإجراءات",
    "no_data": "لا توجد بيانات",
    "loading": "جارٍ تحميل البيانات…",
    "label": "جدول"
  },
  "error_boundary": {
    "title": "صافرة تقنية !",
    "subtitle": "أشار الحكم إلى خطأ تقني",
    "description": "حدث خطأ غير متوقع",
    "detail": "لا يمكننا تحميل بيانات الحكام والمباريات في الوقت الحالي. تم إشعار فريقنا التقني وهو يعمل على حل المشكلة.",
    "refresh_btn": "تحديث الصفحة",
    "home_btn": "العودة للرئيسية",
    "help_text": "إذا استمرت المشكلة، تواصل مع الدعم التقني",
    "tips_title": "نصائح لحل المشكلة",
    "tip_internet": "تحقق من اتصالك بالإنترنت",
    "tip_cache": "جرّب مسح ذاكرة التخزين المؤقت للمتصفح",
    "tip_browser": "تأكد من استخدام أحدث إصدار من المتصفح",
    "tip_extensions": "عطّل امتدادات المتصفح مؤقتًا"
  },
  "support": {
    "page_title": "الدعم والمساعدة",
    "contact_title": "اتصل بنا",
    "faq_title": "الأسئلة الشائعة",
    "guides_title": "أدلة الاستخدام",
    "extra_help_title": "هل تحتاج إلى مزيد من المساعدة؟",
    "back_home_btn": "العودة إلى الصفحة الرئيسية",
    "footer_copyright": "© 2025 مباراتي - Moubarati. جميع الحقوق محفوظة.",
    "guides_note_label": "ملاحظة:",
    "guides_note_text": "الأدلة التفصيلية متاحة من مسؤول الرابطة الخاص بك.",
    "contact_intro": "لأي سؤال أو مساعدة، لا تتردد في الاتصال بنا:",
    "extra_help_text": "إذا لم تجد إجابة لسؤالك في هذه الصفحة، أو إذا واجهت مشكلة فنية، يرجى الاتصال مباشرة بمسؤول الرابطة الخاص بك أو مراسلتنا على عنوان البريد الإلكتروني المذكور أعلاه.",
    "faq": {
      "q1": "كيف يمكنني الوصول إلى جدول التحكيم الخاص بي؟",
      "a1": "قم بتسجيل الدخول إلى حسابك وانتقل إلى قسم 'التخطيط' من القائمة الرئيسية. ستجد جميع المباريات المخصصة لك مع التفاصيل الكاملة.",
      "q2": "كيف أدير توفري؟",
      "a2": "في قسم 'الحكام'، انقر على ملفك الشخصي وانتقل إلى علامة التبويب 'التوفر'. يمكنك الإشارة إلى فترات عدم توفرك.",
      "q3": "أين يمكنني الاطلاع على مدفوعاتي؟",
      "a3": "معلومات الدفع متاحة في قسم 'المالية'. ستجد سجل تعويضاتك وحالة مدفوعاتك.",
      "q4": "كيف أحدث بياناتي البنكية (RIB)؟",
      "a4": "اتصل بمسؤول الرابطة الخاص بك لتحديث RIB الخاص بك. يجب التحقق من صحة التغييرات المصرفية لضمان أمان المدفوعات.",
      "q5": "ماذا أفعل في حالة وجود خطأ في التعيين؟",
      "a5": "اتصل على الفور بمسؤول الرابطة عبر البريد الإلكتروني المشار إليه أدناه. يمكن إجراء التصحيحات قبل التحقق النهائي.",
      "q6": "كيف أطلع على سجل مهامي؟",
      "a6": "سجلك الكامل متاح في ملف الحكم الخاص بك. يمكنك التصفية حسب الموسم ونوع المباراة ورؤية جميع الإحصائيات التفصيلية."
    },
    "guides": {
      "guide1_title": "دليل البدء السريع",
      "guide1_desc": "اكتشف الميزات الأساسية للمنصة",
      "guide2_title": "إدارة التعيينات",
      "guide2_desc": "فهم نظام تعيين الحكام للمباريات",
      "guide3_title": "نظام الدفع",
      "guide3_desc": "كل ما تحتاج لمعرفته حول التعويضات وعملية الدفع"
    }
  },
  "privacy": {
    "page_subtitle": "سياسة الخصوصية",
    "last_updated": "آخر تحديث / Dernière mise à jour : يونيو 2026",
    "commitment_title": "التزامنا",
    "section1_title": "١. البيانات المجمعة",
    "section1_personal": "المعلومات الشخصية",
    "section1_activity": "بيانات النشاط",
    "section1_technical": "البيانات التقنية",
    "section2_title": "٢. استخدام البيانات",
    "section3_title": "٣. أمن البيانات",
    "section4_title": "٤. مشاركة البيانات",
    "section5_title": "٥. حقوقك",
    "right_access": "حق الوصول",
    "right_rectification": "حق التصحيح",
    "right_erasure": "حق المحو",
    "right_portability": "حق النقل",
    "section6_title": "٦. ملفات تعريف الارتباط والتقنيات المماثلة",
    "section7_title": "٧. الاحتفاظ بالبيانات",
    "section8_title": "٩. الاتصال والشكاوى",
    "section9_title": "١٠. تعديلات السياسة",
    "back_home_btn": "العودة إلى الصفحة الرئيسية",
    "footer_copyright": "© 2026 مباراتي - Moubarati. جميع الحقوق محفوظة.",
    "commitment_text": "تجمع مباراتي منصة ويب لإدارة الحكام وثلاثة تطبيقات للهاتف المحمول: مباراتي للحكام، مباراتي للجماهير (Moubarati Live)، ومباراتي للإعلام. نلتزم بحماية خصوصية وأمان بياناتك الشخصية عبر جميع هذه المنتجات. توضح هذه السياسة البيانات التي نجمعها وكيفية استخدامها وكيفية حمايتها.",
    "section1_personal_items": [
      "الاسم الكامل، الاسم الأول، تاريخ الميلاد",
      "معلومات الاتصال (البريد الإلكتروني، الهاتف، العنوان)",
      "معلومات التعريف (رقم الترخيص، فئة الحكم)",
      "البيانات البنكية (RIB) لمعالجة المدفوعات",
      "الموقع الجغرافي (الولاية، الدائرة، البلدية)"
    ],
    "section1_activity_items": [
      "التعيينات للمباريات والمهام",
      "سجل الأداء والتقييمات",
      "التوفر وعدم التوفر المعلن",
      "سجل المدفوعات والتعويضات",
      "الإجراءات التأديبية (إن وجدت)"
    ],
    "section1_technical_items": [
      "عنوان IP ومعلومات الاتصال",
      "نوع المتصفح والجهاز المستخدم",
      "بيانات الجلسة وملفات تعريف الارتباط للمصادقة",
      "سجلات التدقيق للأمان والامتثال"
    ],
    "section2_intro": "يتم استخدام بياناتك الشخصية حصريًا في إطار إدارة أنشطة التحكيم وعمليات الرابطة:",
    "section2_items": [
      "تعيين الحكام للمباريات والمهام",
      "حساب ومعالجة تعويضات السفر والتحكيم",
      "إدارة التوفر وجدولة المباريات",
      "إبلاغ المعلومات المتعلقة بالتعيينات",
      "إنشاء المستندات الرسمية (أوامر المهمة، كشوفات الدفع)",
      "المتابعة التأديبية وإدارة العقوبات",
      "التدقيق والامتثال التنظيمي",
      "تحسين خدمات المنصة",
      "إرسال الإشعارات (الاستدعاءات، التنبيهات، الأخبار) عبر تطبيقات الهاتف المحمول",
      "تحديد مواقع الملاعب أثناء عمليات التدقيق الميداني (تطبيق الحكام)",
      "التقاط أدلة التدقيق ووثائق الاعتماد عبر الكاميرا",
      "تشخيص استقرار التطبيقات وتصحيح الأخطاء"
    ],
    "section3_intro": "نطبق تدابير أمنية تقنية وتنظيمية لحماية بياناتك من أي وصول غير مصرح به أو فقدان أو تعديل:",
    "section3_items": [
      {
        "label": "تشفير SSL/TLS",
        "text": "جميع الاتصالات مشفرة"
      },
      {
        "label": "مصادقة آمنة",
        "text": "وصول محمي بكلمة مرور وجلسات آمنة"
      },
      {
        "label": "أمان على مستوى الصفوف (RLS)",
        "text": "سياسات أمان على مستوى البيانات"
      },
      {
        "label": "سجلات تدقيق كاملة",
        "text": "تتبع جميع التعديلات"
      },
      {
        "label": "استضافة آمنة",
        "text": "بنية تحتية Supabase متوافقة مع المعايير الدولية"
      },
      {
        "label": "التحكم في الوصول",
        "text": "أذونات قائمة على الأدوار والروابط"
      }
    ],
    "section4_intro": "لا يتم بيع بياناتك الشخصية أبدًا لأطراف ثالثة. يمكن مشاركتها فقط في الحالات التالية:",
    "section4_items": [
      "مع رابطتك المخصصة لإدارة التعيينات",
      "مع المؤسسات المصرفية لمعالجة المدفوعات (RIB فقط)",
      "مع مقدمي الخدمات التقنية (Supabase) في إطار الاستضافة الآمنة",
      "بناءً على طلب السلطات القانونية المختصة (التزام قانوني)"
    ],
    "section5_intro": "وفقًا للوائح السارية، لديك الحقوق التالية:",
    "right_access_desc": "الاطلاع على بياناتك الشخصية المخزنة في المنصة",
    "right_rectification_desc": "تصحيح المعلومات غير الدقيقة أو غير المكتملة",
    "right_erasure_desc": "طلب حذف بياناتك (رهنًا بالالتزامات القانونية)",
    "right_portability_desc": "استلام بياناتك بتنسيق منظم",
    "rights_contact": "لممارسة حقوقك، اتصل بنا على:",
    "section6_intro": "نستخدم ملفات تعريف الارتباط والتقنيات المماثلة من أجل:",
    "section6_items": [
      "الحفاظ على جلسة المصادقة الآمنة الخاصة بك",
      "تذكر تفضيلاتك (اللغة، العرض)",
      "تحليل استخدام المنصة لتحسينها"
    ],
    "section6_note": "ملفات تعريف الارتباط الأساسية ضرورية لعمل المنصة ولا يمكن تعطيلها.",
    "section7_intro": "يتم الاحتفاظ ببياناتك الشخصية طوال المدة اللازمة للأغراض التي تم جمعها من أجلها، ووفقًا للالتزامات القانونية:",
    "section7_items": [
      "بيانات التحكيم النشط: خلال نشاطك + 3 سنوات أرشيف",
      "السجل المالي: 10 سنوات (الالتزامات المحاسبية)",
      "البيانات التأديبية: المدة التنظيمية حسب نوع العقوبة",
      "سجلات التدقيق: 5 سنوات على الأقل للامتثال"
    ],
    "section8_intro": "لأي سؤال بخصوص سياسة الخصوصية هذه أو لممارسة حقوقك:",
    "section8_email_label": "البريد الإلكتروني:",
    "section8_response_note": "نلتزم بالرد على أي طلب في غضون 30 يومًا.",
    "section9_text": "نحتفظ بالحق في تعديل سياسة الخصوصية هذه في أي وقت. سيتم إبلاغ أي تعديل كبير عبر المنصة أو عن طريق البريد الإلكتروني.",
    "section9_last_updated": "تاريخ آخر تحديث: يونيو 2026",
    "section1_intro": "تجمع مباراتي أربعة منتجات: منصة الويب لإدارة الحكام وثلاثة تطبيقات للهاتف المحمول (مباراتي للحكام، مباراتي للجماهير، ومباراتي للإعلام). تجمع منصة الويب وحسابات المستخدمين البيانات المشتركة الموضحة أدناه؛ ويضيف كل تطبيق محمول البيانات المذكورة في بطاقته. أما بيانات الترخيص وحساب RIB والإجراءات التأديبية وتاريخ المدفوعات الموضحة أدناه فتخص الحكام فقط.",
    "section1_common_title": "البيانات المشتركة (منصة الويب والحسابات)",
    "section1_apps_title": "البيانات الخاصة بتطبيقات الهاتف المحمول",
    "apps": [
      {
        "name": "مباراتي للحكام (Officiel)",
        "data": [
          "تحديد الموقع الجغرافي الدقيق (GPS): يُستخدم فقط أثناء عمليات تدقيق الملاعب، وبعد موافقتك الصريحة",
          "الكاميرا والصور: التقاط الأدلة المصوّرة أثناء تدقيق الملاعب",
          "رمز الإشعارات (push) عبر Google FCM / Apple APNs لإرسال الاستدعاءات والتنبيهات",
          "معلومات الجهاز (الطراز، نظام التشغيل، إصدار التطبيق)",
          "تشخيص الأعطال والأخطاء عبر Sentry لضمان استقرار التطبيق",
          "تخزين رمز المصادقة محلياً وبشكل آمن على جهازك"
        ]
      },
      {
        "name": "مباراتي للجماهير (Moubarati Live)",
        "data": [
          "الحساب وبيانات الاتصال (البريد الإلكتروني، المعرّف)",
          "رمز الإشعارات (push) عبر Google FCM / Apple APNs للأخبار وتنبيهات المباريات",
          "معلومات الجهاز (الطراز، نظام التشغيل، إصدار التطبيق)",
          "صورة ملف شخصي اختيارية تختار إضافتها",
          "تخزين جلستك محلياً على جهازك"
        ]
      },
      {
        "name": "مباراتي للإعلام (الاعتماد الصحفي)",
        "data": [
          "الهوية وبيانات طلب الاعتماد (الاسم، الجهة الإعلامية، الوظيفة)",
          "الكاميرا والصور: التقاط الوثائق وصور الهوية لأغراض الاعتماد",
          "قد يُطلب الميكروفون من قِبل وحدة الكاميرا؛ لا نحتفظ بأي تسجيل صوتي",
          "تخزين بيانات الطلب محلياً على جهازك"
        ]
      }
    ],
    "section4_processors_intro": "نستعين بمزوّدي خدمات تقنيين (معالِجين) يعالجون البيانات نيابةً عنا، دون بيعها أبداً:",
    "section4_processors": [
      {
        "label": "Supabase",
        "text": "استضافة قاعدة البيانات والمصادقة وتخزين الملفات"
      },
      {
        "label": "Expo وGoogle FCM وApple APNs",
        "text": "توصيل الإشعارات الفورية إلى جهازك"
      },
      {
        "label": "Sentry",
        "text": "تشخيص الأعطال والأخطاء (تطبيق الحكام فقط)"
      },
      {
        "label": "SendGrid",
        "text": "إرسال رسائل البريد الإلكتروني (التأكيدات وإعادة التعيين)"
      }
    ],
    "deletion_title": "٨. حذف الحساب والبيانات",
    "deletion_intro": "يمكنك طلب حذف حسابك وبياناتك الشخصية في أي وقت، دون الحاجة إلى تثبيت التطبيق:",
    "deletion_items": [
      "أرسل طلبك عبر البريد الإلكتروني إلى lirf@moubarati.com مع كتابة «حذف الحساب» في الموضوع",
      "اذكر البريد الإلكتروني المرتبط بحسابك والتطبيق المعني (الحكام، الجماهير، أو الإعلام)",
      "سيتم حذف بياناتك الشخصية خلال مدة أقصاها 30 يوماً بعد التحقق من هويتك"
    ],
    "deletion_retained_note": "قد يتم الاحتفاظ ببعض البيانات عندما يقتضي القانون ذلك، لا سيما السجل المالي (10 سنوات) وسجلات التدقيق (5 سنوات)، حتى بعد حذف حسابك.",
    "section6_mobile_note": "لا تستخدم تطبيقات الهاتف المحمول ملفات تعريف الارتباط (cookies)؛ بل تخزّن فقط معلومات الجلسة الضرورية محلياً على جهازك."
  },
  "yes": "نعم",
  "no": "لا",
  "no_team": "لا يوجد فريق",
  "values": {
    "not_available": "غير متوفر"
  },
  "season_readonly": {
    "banner": "موسم مؤرشف — للقراءة فقط",
    "super_admin_hint": "التعديل مقصور على المشرف الأعلى",
    "blocked": "إجراء غير متاح: الموسم مؤرشف"
  },
  "season_not_live": {
    "banner": "الموسم {{season}} لم يُفعَّل بعد: تبقى البيانات غير مكتملة إلى حين انتهاء الانتقال.",
    "go_to_transition": "الذهاب إلى الانتقال",
    "empty_title": "موسم غير مُفعَّل",
    "empty_desc": "أكمل انتقال الموسم لتوليد بيانات هذا الموسم.",
    "status_not_started": "لم تُطلق بعد عملية انتقال الموسم.",
    "status_ongoing": "انتقال الموسم قيد التنفيذ (المرحلة {{done}}/{{total}}).",
    "league_hint": "ستتمكنون من إعداد مجموعاتكم ورزناماتكم بمجرد انتهاء الانتقال.",
    "view_board": "عرض تحضير الموسم"
  },
  "job_center": {
    "calendar_recover_title": "حفظ النتيجة كمرشح",
    "calendar_recover_done_title": "النتيجة محفوظة كمرشح بالفعل",
    "calendar_open_title": "عرض الروزنامة المحسَّنة (فتح المجموعة)",
    "calendar_recovered_label": "المرشح {{n}} — محسَّن — {{date}} (مستعاد)",
    "calendar_recover_done": "تم حفظ النتيجة: {{label}}",
    "calendar_recover_exists": "هذه النتيجة محفوظة كمرشح بالفعل.",
    "calendar_recover_empty": "لا توجد نتيجة قابلة للاستخدام في هذه المهمة.",
    "calendar_recover_no_season": "تعذر العثور على موسم المجموعة — لا يمكن حفظ المرشح.",
    "calendar_recover_failed": "فشل حفظ المرشح.",
    "stop_title": "إيقاف التحسين",
    "retry_title": "إعادة التشغيل (إنشاء مهمة جديدة)",
    "stop_confirm_title": "إيقاف التحسين؟",
    "stop_confirm_body": "سيتوقف الحلّال قريبًا (حتى الحد الزمني). ستُوسم المهمة كملغاة.",
    "stop_confirm_btn": "إيقاف",
    "view": "عرض"
  },
  "stadium_select": {
    "placeholder": "اختر ملعبًا…",
    "search": "ابحث عن ملعب أو بلدية أو ولاية…",
    "no_location": "بدون موقع",
    "no_coords": "بدون إحداثيات",
    "group_league": "ملاعب الرابطة",
    "group_other": "ملاعب أخرى"
  },
  "maintenance": {
    "title": "التطبيق قيد الصيانة",
    "default_message": "التطبيق غير متاح مؤقتًا بسبب أعمال الصيانة. يرجى المحاولة لاحقًا.",
    "expected_end": "الاستئناف المتوقع: {{date}}",
    "retry": "إعادة المحاولة",
    "sign_out": "تسجيل الخروج",
    "banner_title": "الصيانة مفعّلة",
    "banner_scopes": "التطبيقات المعنية: {{scopes}}",
    "banner_writes_blocked": "الكتابة موقوفة",
    "banner_manage": "إدارة",
    "scopes": {
      "web": "تطبيق الويب",
      "officiels": "تطبيق الحكام",
      "fans": "تطبيق الجماهير",
      "media": "تطبيق الإعلام"
    }
  },
  "categories": {
    "filter_label": "الفئة",
    "all": "الكل"
  },
  "cup": {
    "round_label": "الدور",
    "round_unknown": "الدور غير محدد",
    "game_day": "الجولة {{n}}",
    "game_day_short": "ج{{n}}"
  }
}
